import React from 'react';

export type OpenRouterIconProps = React.SVGProps<SVGSVGElement> & {
  title?: string;
  size?: number;
};

export const OpenRouterIcon: React.FC<OpenRouterIconProps> = ({
  title = 'OpenRouter',
  size = 14,
  ...props
}) => {
  const ariaProps = title
    ? { role: 'img' as const, 'aria-label': title }
    : { 'aria-hidden': true as const };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="100 100 100 200"
      {...ariaProps}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <g fill="currentColor" stroke="currentColor">
        <path
          strokeWidth={35.3}
          d="M46.2 200.5c5.9 0 28.6-5.1 40.3-11.8 11.8-6.6 11.8-6.6 36.1-23.9 30.8-21.8 52.5-14.5 88.2-14.5"
        />
        <path
          strokeWidth={0.4}
          d="M245.3 150.5 185 185.3v-69.6l60.3 34.8Z"
        />
        <path
          strokeWidth={35.3}
          d="M45 200.5c5.9 0 28.6 5 40.4 11.7 11.7 6.7 11.7 6.7 36 24 30.8 21.8 52.5 14.5 88.2 14.5"
        />
        <path
          strokeWidth={0.4}
          d="m244.1 250.4-60.3-34.7v69.5l60.3-34.8Z"
        />
      </g>
    </svg>
  );
};
